module.exports = __webpack_public_path__ + "img/th_th.14a3802c.png";